module.exports = __webpack_public_path__ + "static/recommendation-889bb61d877ac829f37cdb3c545767f6.png";